import { defineMessages } from 'react-intl';

export default defineMessages({
  passcodeMsg: {
    defaultMessage:
      'You may be prompted for a passcode in order to place your order. The first person to place the order will receive a passcode, which can be shared.',
  },
});
